import { resolveApiUrl } from "../../../assets/GlobalVariables";
import { ORGANIZED_TOUR_RESOURCE_PROXY_PATH } from "../constants/apiEndpoints";

/**
 * Same-origin proxy for external LDS itinerary PDFs (iframe embed).
 * @param {string|null|undefined} resourceUrl
 * @returns {string|null}
 */
export function buildOrganizedTourResourceProxyUrl(resourceUrl) {
  const direct = String(resourceUrl || "").trim();
  if (!direct || !/^https:\/\//i.test(direct)) return null;
  const base = resolveApiUrl(ORGANIZED_TOUR_RESOURCE_PROXY_PATH);
  return `${base}?url=${encodeURIComponent(direct)}`;
}
